
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import getT from 'next-translate/getT';
import { oneLineTrim } from 'common-tags';
import { FlexibleContent, GridLocation } from '@/templates';
import { getLayout } from '@/layout';
import config from '@/config';
import i18n from '@/i18n';
import { getCommonData, getProvinces } from '@/graphql/api';
import { client } from '@/graphql/client';
import { getEdificios, getPage } from '@/graphql/queries';
import { houseTransformer } from '@/graphql/transformer/houseTransformer';
import { sectionTransformer } from '@/graphql/transformer/sections';
import { errorGrahpQL, getWordpressPath } from '@/graphql/utils';
import type { TypeFlexibleContent } from '@/graphql/transformer/sections';
import type { TypeGridLocationProps } from '@/templates/grid-location';
import type { GetStaticProps } from 'next';
import type { AppCommonProps } from 'pages/_app';
type PageProps = {
    flexibleContent: TypeFlexibleContent[];
    gridLocation: TypeGridLocationProps;
};
export const Location = ({ flexibleContent, gridLocation }: PageProps) => (<>
    <GridLocation {...gridLocation}/>
    <FlexibleContent flexibleContent={flexibleContent}/>
  </>);
const getStaticProps: GetStaticProps<PageProps & AppCommonProps> = async ({ locale: onGoingLocale }) => {
    const locale = onGoingLocale ?? i18n.defaultLocale;
    const page = await client.query({
        query: getPage,
        variables: {
            slug: getWordpressPath({
                slug: '/on-som',
                locale: 'ca',
            }),
        },
    });
    const data = page?.data?.page;
    errorGrahpQL(page);
    if (!data || !data.language.locale.includes(locale))
        return { notFound: true };
    const { contenidoFlexible: { contenido: flexibleContentData = [] }, seo, } = data;
    const buildingsRaw = await client.query({
        query: getEdificios,
        variables: { first: 100, language: locale?.toUpperCase() },
    });
    const buildingsData = buildingsRaw?.data;
    if (buildingsRaw?.errors &&
        Array.isArray(buildingsRaw.errors) &&
        buildingsRaw.errors.length > 0) {
        buildingsRaw.errors.forEach((error) => {
            // eslint-disable-next-line no-console
            if (buildingsData)
                console.error(error);
            else
                throw new Error(error?.debugMessage ?? error.message);
        });
    }
    const buildings: any[] = [];
    buildingsData?.edificios?.edges?.forEach(async (building: any) => {
        const { edificio, locations: { edges = [] } = {} } = building?.node;
        // A building technically can have multiple locations,
        // but in the practice the building can only have one location
        const locations = edges.filter((location: any) => location?.node?.ancestors !== null);
        const ancestors: any[] = locations?.at(0)?.node?.ancestors?.edges ?? [];
        const subtitle = oneLineTrim `
        ${edificio?.nombre}
        ${ancestors.length > 0 ? ', ' : ''}
        ${ancestors.map((ancestor: any) => ancestor?.node?.name).join(', ')}`;
        const buildingsTemp = await houseTransformer(building?.node?.edificio, locale, building.node.databaseId);
        buildings.push({ ...buildingsTemp, subtitle });
    });
    const { provinces } = await getProvinces(locale);
    const databaseId = data?.contenido?.edificio?.databaseId;
    const province = data?.contenido?.province;
    const flexibleContent = await sectionTransformer({
        flexibleContent: flexibleContentData,
        building: null,
        locale: locale ?? i18n.defaultLocale,
        buildingId: databaseId,
        province,
    });
    const { footer, header } = await getCommonData({
        locale: locale ?? i18n.defaultLocale,
        content: data.contenido,
        translations: data.translations,
    });
    const t = await getT(locale, ['location', 'common']);
    return {
        props: {
            seo,
            flexibleContent,
            header,
            footer,
            gridLocation: {
                buildings,
                pretitle: t('pretitle'),
                title: t('title', { location: t('country') }),
                description: t('description', {
                    location: t('country'),
                    quantity: buildings.length,
                }),
                ancestor: null,
                searchBox: {
                    provinces: {
                        values: provinces,
                        placeholder: t('common:components.molecules.searchBoxLocations.province'),
                    },
                    cities: {
                        citiesList: [],
                        values: [],
                        placeholder: t('common:components.molecules.searchBoxLocations.city'),
                    },
                },
            },
        },
        revalidate: config.revalidate,
        notFound: !data,
    };
};
Location.getLayout = getLayout;
export default Location;

    async function __Next_Translate__getStaticProps__19a538d0c2c__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/on-som/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19a538d0c2c__ as getStaticProps }
  